/*
 * Agent draft stores for managing agent transmit/receive content
 */

import type { DraftContent } from '@repo/common';
import { writable } from 'svelte/store';

/**
 * Agent receive (Rx) - content received from agent to display
 */
export const agentRx = writable<DraftContent | null>(null);

/**
 * Agent transmit (Tx) - content to send to agent
 */
export const agentTx = writable<DraftContent | null>(null);
